import React from 'react';
import Logo from './Logo';
import { useLanguage } from '../context/LanguageContext';
import { getTranslations } from '../utils/translations';
import './Hero.css';

export default function Hero() {
  const { language } = useLanguage();
  const t = getTranslations(language);
  
  return (
    <section className="hero">
      <video 
        className="hero-video-background" 
        autoPlay 
        loop 
        muted 
        playsInline
      >
        <source src="/videos/tourism-background.mp4" type="video/mp4" />
        {/* Fallback image if video doesn't load */}
        Your browser does not support the video tag.
      </video>
      <div className="hero-overlay"></div>
      <div className="hero-content">
        <div className="hero-logo-container">
          <Logo />
        </div>
        <h2 className="hero-subtitle">{t.hero.subtitle}</h2>
        <p className="hero-description">
          {t.hero.description}
        </p>
        <button className="hero-cta" onClick={() => {
          const element = document.getElementById('destinations');
          if (element) element.scrollIntoView({ behavior: 'smooth' });
        }}>{t.hero.cta}</button>
      </div>
    </section>
  );
}

